<template lang="html">
  <div class="flex items-center justify-between h3 ph2 bb">
    <div class="left flex items-center">
      <h3>Saved Floorplans</h3>
    </div>
    <div class="right flex items-center">

      <!-- Toggle list button -->
      <div class="ph2 mh2 pointer user-select-none" @click="TOGGLE_LIST_VIEW()">
        <i class="material-icons br pr1" :class="{'o-50': listMode}">&#xE8F0;</i>
        <i class="material-icons pl" :class="{'o-50': !listMode}">&#xE8FE;</i>
      </div>

      <!-- Toggle favourites -->
      <div class="close-btn">
        <button class="pointer bn ph3" @click="TOGGLE_VIEWING_FAVOURITES()">
          <i class="material-icons">&#xE5CD;</i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'floorplan-favourites-action-bar',
  computed: {
    ...mapGetters(['listMode', 'favourites'])
  },
  methods: {
    ...mapActions(['TOGGLE_VIEWING_FAVOURITES', 'TOGGLE_LIST_VIEW'])
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanFavourites/FloorplanFavouritesActionBar.vue